module.exports = __webpack_public_path__ + "media/courses/decal-36c4f75b.png";